import {
    TYPE_OF_CHARGES_CREATE,
    TYPE_OF_CHARGES_CREATE_FAIL,
    TYPE_OF_CHARGES_CREATE_SUCCESS,
    DELETE_TYPE_OF_CHARGES,
    DELETE_TYPE_OF_CHARGES_FAIL,
    DELETE_TYPE_OF_CHARGES_SUCCESS,
    GET_TYPE_OF_CHARGESES,
    GET_TYPE_OF_CHARGESES_FAIL,
    GET_TYPE_OF_CHARGESES_SUCCESS,
    GET_TYPE_OF_CHARGES_DETAILS,
    GET_TYPE_OF_CHARGES_DETAILS_FAIL,
    GET_TYPE_OF_CHARGES_DETAILS_SUCCESS,
    RESET,
    RESET_TYPE_OF_CHARGES_CREATE,
    RESET_TYPE_OF_CHARGES_DELETE,
    RESET_TYPE_OF_CHARGES_DETAILS,
    UPDATE_TYPE_OF_CHARGES,
    UPDATE_TYPE_OF_CHARGES_FAIL,
    UPDATE_TYPE_OF_CHARGES_SUCCESS,
} from "./actionsTypes";

const initialState = {
    typeOfChargesList: [],
    typeOfChargesDetails: [],
    createResult: {},
    loading: false,
    detailsLoading: false,
    loadingCreate: false,
    deleteResult: {},
    error: {
        message: "",
    },
};

const TypeOfChargesReducer = (state = initialState, action) => {
    if (!action) return state;

    switch (action.type) {
        case TYPE_OF_CHARGES_CREATE:
            state = { ...state, createResult: {}, loadingCreate: true };
            break;
        case TYPE_OF_CHARGES_CREATE_SUCCESS:
            state = { ...state, createResult: action.payload, loadingCreate: false };
            break;
        case TYPE_OF_CHARGES_CREATE_FAIL:
            state = {
                ...state,
                error: {
                    message: "Error",
                },
                createResult: {},
                loadingCreate: false,
            };
            break;

        case GET_TYPE_OF_CHARGESES:
            state = { ...state, loading: true };
            break;
        case GET_TYPE_OF_CHARGESES_SUCCESS:
            state = { ...state, typeOfChargesList: action.payload, loading: false };
            break;
        case GET_TYPE_OF_CHARGESES_FAIL:
            state = {
                ...state,
                error: {
                    message: "Error",
                },
                loading: false,
            };
            break;

        case GET_TYPE_OF_CHARGES_DETAILS:
            state = { ...state, detailsLoading: true, typeOfChargesDetails: {} };
            break;
        case GET_TYPE_OF_CHARGES_DETAILS_SUCCESS:
            state = { ...state, typeOfChargesDetails: action.payload, detailsLoading: false };
            break;
        case GET_TYPE_OF_CHARGES_DETAILS_FAIL:
            state = {
                ...state,
                error: {
                    message: "Error",
                },
                detailsLoading: false,
            };
            break;

        case UPDATE_TYPE_OF_CHARGES:
            state = { ...state, createResult: {}, loading: true };
            break;
        case UPDATE_TYPE_OF_CHARGES_SUCCESS:
            state = { ...state, createResult: action.payload, loading: false };
            break;
        case UPDATE_TYPE_OF_CHARGES_FAIL:
            state = {
                ...state,
                error: {
                    message: "Error",
                },
                loading: false,
            };
            break;

        case DELETE_TYPE_OF_CHARGES:
            state = { ...state, deleteResult: {}, loading: true, };
            break;
        case DELETE_TYPE_OF_CHARGES_SUCCESS:
            state = { ...state, deleteResult: action.payload, loading: false };
            break;
        case DELETE_TYPE_OF_CHARGES_FAIL:
            state = {
                ...state,
                error: {
                    message: "Error",
                },
                loading: false,
                deleteResult: {}
            };
            break;
        case RESET_TYPE_OF_CHARGES_DETAILS:
            state = { ...state, typeOfChargesDetails: {}, detailsLoading: false };
            break;

        case RESET:
            state = { ...state, typeOfChargesList: [], createResult: {} };
            break;
        case RESET_TYPE_OF_CHARGES_CREATE:
            state = { ...state, createResult: {} };
            break;
        case RESET_TYPE_OF_CHARGES_DELETE:
            state = { ...state, deleteResult: {} };
            break;
        default:
            state = { ...state };
            break;
    }
    return state;
};

export default TypeOfChargesReducer;